import { selectComponentState } from 'projectRedux/store';
import { extraComponentAdapter } from '../adapters/extraComponentAdapter';

export const {
  selectAll: selectAllExtraComponents,
  selectById: selectExtraComponentById,
  selectEntities: selectExtraComponentEntities,
} = extraComponentAdapter.getSelectors((state) => selectComponentState(state).extraComponents);
